var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendericon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6940",
    "data-name": "Rectangle 6940",
    width: 24,
    height: 24,
    transform: "translate(319 13065)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_133",
    "data-name": "Mask Group 133",
    transform: "translate(-319 -13065)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar-empty-svgrepo-com",
    transform: "translate(322.954 13069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15887",
    "data-name": "Group 15887"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6938",
    "data-name": "Rectangle 6938",
    width: 0.971,
    height: 1.911,
    transform: "translate(4)",
    fill: "#6f6f70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6939",
    "data-name": "Rectangle 6939",
    width: 1,
    height: 1.906,
    transform: "translate(11)",
    fill: "#6f6f70"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15886",
    "data-name": "Group 15886",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15136",
    "data-name": "Path 15136",
    d: "M15.976,3.959v-2.5a1.377,1.377,0,0,0-1.354-1.4h-1.59V2.084H9.968V.058H6.034V2.084h-3.1V.058H1.4a1.377,1.377,0,0,0-1.354,1.4v2.5Z",
    fill: "#6f6f70",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15137",
    "data-name": "Path 15137",
    d: "M.046,5v8.562a1.377,1.377,0,0,0,1.354,1.4H14.621a1.377,1.377,0,0,0,1.354-1.4V5Z",
    fill: "#6f6f70",
    fillRule: "evenodd"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendericon);
export default __webpack_public_path__ + "static/media/calendericon.5c315c2c1f8812fb20ea96811fede43d.svg";
export { ForwardRef as ReactComponent };